import script from "./NewsSinglePage.vue?vue&type=script&setup=true&lang=js"
export * from "./NewsSinglePage.vue?vue&type=script&setup=true&lang=js"

import "./NewsSinglePage.vue?vue&type=style&index=0&id=670ed7bb&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-670ed7bb"]])

export default __exports__